<footer class="main-footer">
    <div style="text-align: center;">
        <p>Derechos de autor 2022 © GIF</p>
    </div>
</footer>
